import mongoose from 'mongoose';
import userSchema, { IUserDocument } from '../schemas/user';

export default (mongoose.models.User ||
  mongoose.model<IUserDocument>('User', userSchema)) as mongoose.Model<IUserDocument>;
